import { render, staticRenderFns } from "./ClientCards.vue?vue&type=template&id=1a28ba2e&"
import script from "./ClientCards.vue?vue&type=script&lang=js&"
export * from "./ClientCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports